(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/player-registration/assets/react/pages/register/register.js') >= 0) return;  svs.modules.push('/modules/player-registration/assets/react/pages/register/register.js');
'use strict';

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const _React = React,
  useState = _React.useState;
const _ReactRouterDOM = ReactRouterDOM,
  useHistory = _ReactRouterDOM.useHistory;
const Button = svs.ui.ReactButton;
const StepIndicatorBalls = svs.components.tb_ui.stepIndicatorBalls.StepIndicatorBalls;
const _svs$ui$reactForm = svs.ui.reactForm,
  Form = _svs$ui$reactForm.Form,
  ControlGroup = _svs$ui$reactForm.ControlGroup,
  Inputv2 = _svs$ui$reactForm.Inputv2;
const GridBase = svs.tb_ui_react.gridbase.GridBase;
const ReactInfoButtonText = svs.tb_ui.ReactInfoButtonText;
const helpers = svs.playerRegistration.helpers;
const service = svs.playerRegistration.service;
const trackCustomerRegistrationAsync = svs.playerRegistration.tracking.trackCustomerRegistrationAsync;
const _svs$playerRegistrati = svs.playerRegistration.dialogs,
  showTechnicalError = _svs$playerRegistrati.showTechnicalError,
  showHowWeUseInfoDialog = _svs$playerRegistrati.showHowWeUseInfoDialog,
  showExpiredIdentificationDialog = _svs$playerRegistrati.showExpiredIdentificationDialog,
  showCantBecomeACustomer = _svs$playerRegistrati.showCantBecomeACustomer;
const routes = svs.playerRegistration.constants.routes;
const _svs$playerRegistrati2 = svs.playerRegistration.components,
  Header = _svs$playerRegistrati2.Header,
  Footer = _svs$playerRegistrati2.Footer,
  DesktopContentConstrain = _svs$playerRegistrati2.DesktopContentConstrain,
  PageTitle = _svs$playerRegistrati2.PageTitle,
  FadeInSlideWrapper = _svs$playerRegistrati2.FadeInSlideWrapper,
  GeneralTermsDocLink = _svs$playerRegistrati2.GeneralTermsDocLink,
  PersonalInformationDocLink = _svs$playerRegistrati2.PersonalInformationDocLink,
  GameRulesPageLink = _svs$playerRegistrati2.GameRulesPageLink;
let warningMessageTimer;
const modes = {
  REACTIVATED_EMAIL: 0,
  REACTIVATED_NO_EMAIL: 1,
  RETAIL: 2,
  NEW: 3
};
const Register = () => {
  var _svs$playerRegistrati3, _customer$email;
  const history = useHistory();
  const _ReactRedux$useSelect = ReactRedux.useSelector(state => state.playerregistrationreact),
    startTime = _ReactRedux$useSelect.startTime;
  const customer = (_svs$playerRegistrati3 = svs.playerRegistration.data) === null || _svs$playerRegistrati3 === void 0 ? void 0 : _svs$playerRegistrati3.customer;
  const extraData = ReactRedux.useSelector(state => state.playerregistrationreact);
  const isRetail = extraData.isRetailCustomer;
  const isReactivatedEmail = extraData.isReactivatedCustomer && Boolean(customer === null || customer === void 0 ? void 0 : customer.email);
  const isReactivatedNoEmail = extraData.isReactivatedCustomer && !(customer !== null && customer !== void 0 && customer.email);
  const returnUrl = helpers.getReturnUrl() || svs.core.urlMapping.get('newCustomer');
  const isNewCustomerOnlyStep1 = returnUrl === svs.core.urlMapping.get('newCustomer');
  const isShortRegistrationFlow = extraData.isShortRegistrationFlow || isNewCustomerOnlyStep1;
  const _useState = useState((customer === null || customer === void 0 ? void 0 : customer.mobile) || ''),
    _useState2 = _slicedToArray(_useState, 2),
    mobile = _useState2[0],
    setMobile = _useState2[1];
  const _useState3 = useState((customer === null || customer === void 0 || (_customer$email = customer.email) === null || _customer$email === void 0 ? void 0 : _customer$email.toLowerCase()) || ''),
    _useState4 = _slicedToArray(_useState3, 2),
    email = _useState4[0],
    setEmail = _useState4[1];
  const _useState5 = useState(true),
    _useState6 = _slicedToArray(_useState5, 2),
    validMobile = _useState6[0],
    setValidMobile = _useState6[1];
  const _useState7 = useState(true),
    _useState8 = _slicedToArray(_useState7, 2),
    validEmail = _useState8[0],
    setValidEmail = _useState8[1];
  const _useState9 = useState(''),
    _useState0 = _slicedToArray(_useState9, 2),
    emailCustomError = _useState0[0],
    setEmailCustomError = _useState0[1];
  const _useState1 = useState(''),
    _useState10 = _slicedToArray(_useState1, 2),
    mobileCustomError = _useState10[0],
    setMobileCustomError = _useState10[1];
  const _useState11 = useState(false),
    _useState12 = _slicedToArray(_useState11, 2),
    isButtonDisabled = _useState12[0],
    setIsButtonDisabled = _useState12[1];
  let mode;
  switch (true) {
    case isReactivatedEmail:
      mode = modes.REACTIVATED_EMAIL;
      break;
    case isReactivatedNoEmail:
      mode = modes.REACTIVATED_NO_EMAIL;
      break;
    case isRetail:
      mode = modes.RETAIL;
      break;
    default:
      mode = modes.NEW;
      break;
  }
  const navigateToNext = async (showKycQuestions, isBlocked) => {
    const queryString = returnUrl ? "?returnUrl=".concat(encodeURIComponent(returnUrl)) : '';
    const customerRegistrationCompletionUrl = svs.core.urlMapping.get('customerRegistrationCompletion');
    const accountCreatedUrl = "".concat(customerRegistrationCompletionUrl).concat(routes.ACCOUNT_CREATED).concat(queryString);
    const kycUrl = "".concat(routes.KYC).concat(queryString);

    if (showKycQuestions) {
      history.push(kycUrl);
      return;
    } else if (isBlocked) {
      const showNationalSuspensionMessage = () => new Promise(resolve => {
        svs.accountservices.national_suspension_message.showNationalSuspensionMessage(() => resolve());
      });
      await showNationalSuspensionMessage();
    }

    if (isShortRegistrationFlow) {
      svs.utils.url.navigate(svs.utils.url.makeInternal(returnUrl, svs.core.urlMapping.get('startPage')));
    } else {
      svs.utils.url.navigate(svs.utils.url.makeInternal(accountCreatedUrl, svs.core.urlMapping.get('startPage')));
    }
  };
  const handleInputChange = e => {
    e.preventDefault();
    if (warningMessageTimer) {
      clearTimeout(warningMessageTimer);
    }
    const value = e.target.value;
    if (e.target.name === 'email') {
      const isValidEmail = helpers.validateEmail(value);
      setEmailCustomError('');
      setEmail(value);
      if (!isValidEmail) {
        warningMessageTimer = setTimeout(() => {
          setValidEmail(false);
        }, 1000);
      } else {
        setValidEmail(true);
      }
    } else {
      const isValidMobile = helpers.validatePhoneNumber(value);
      setMobileCustomError('');
      let formattedNumber = value;
      if (formattedNumber.length > 2 && formattedNumber.slice(0, 2) === '46') {
        formattedNumber = "0".concat(formattedNumber.slice(2));
      }
      if (formattedNumber.length > 3 && formattedNumber.slice(0, 3) === '+46') {
        formattedNumber = "0".concat(formattedNumber.slice(3));
      }
      if (formattedNumber.length > 4 && formattedNumber.slice(0, 4) === '0046') {
        formattedNumber = "0".concat(formattedNumber.slice(4));
      }
      setMobile(formattedNumber);
      if (!isValidMobile) {
        warningMessageTimer = setTimeout(() => {
          setValidMobile(false);
        }, 1000);
      } else {
        setValidMobile(true);
      }
    }
  };
  const onRegistrationError = err => {
    if (err) {
      switch (err.code) {
        case 10050:
          setEmailCustomError('Ange giltig e-postadress');
          break;
        case 10056:
          setEmailCustomError('E-postadressen är registrerad på en annan kund');
          break;
        case 12110:
          setMobileCustomError('Felaktigt mobilnummer');
          break;
        case 12560:
          showCantBecomeACustomer();
          break;
        case 12570:
          setMobileCustomError('Mobilnumret är registrerad på en annan kund');
          break;
        case 12580:
        case 12581:
          showExpiredIdentificationDialog();
          break;
        default:
          svs.playerRegistration.logger.warn('Customer registration technical error', err);
          showTechnicalError();
          break;
      }
    } else {
      svs.playerRegistration.logger.warn('Customer registration technical error, no error object');
      showTechnicalError();
    }
  };
  const handleSubmit = async e => {
    e.preventDefault();
    if (isButtonDisabled) {
      return;
    }
    setIsButtonDisabled(true);
    const customerData = {
      postToken: customer.token,
      email,
      source: helpers.getDevice()
    };
    if (mobile.length > 0) {
      const formattedNumber = mobile.replace(/\+46/, '0').replace(/^0046+/, '0').replace(/-|\s/g, '');
      customerData.cellPhone = formattedNumber;
    }
    if (validMobile || validEmail) {
      var _registerCustomerResp, _registerCustomerResp2;
      const registerCustomerResponse = await service.registerCustomerAsync(customerData, customer.eid);
      const trackingLabel = customer.eid === 'frejaeid' ? 'frejaeid' : 'bankid';
      if (registerCustomerResponse.error) {
        onRegistrationError(registerCustomerResponse.error);
        return;
      }
      const preferencesResponse = await service.checkFreshPreferencesDataAsync();
      if (preferencesResponse.error) {
        svs.playerRegistration.logger.warn('Could not retrieve preferences, going to forward new customer without having verified preferences.', preferencesResponse.error);
      }

      await svs.accountservices.martech_helper.setPersonalizedContentFlag();

      if (startTime) {
        await trackCustomerRegistrationAsync({
          label: trackingLabel,
          duration: Date.now() - startTime
        });
      }
      const showKycQuestions = Boolean(registerCustomerResponse === null || registerCustomerResponse === void 0 || (_registerCustomerResp = registerCustomerResponse.data) === null || _registerCustomerResp === void 0 || (_registerCustomerResp = _registerCustomerResp.session) === null || _registerCustomerResp === void 0 ? void 0 : _registerCustomerResp.showKycQuestions);
      const isBlocked = registerCustomerResponse === null || registerCustomerResponse === void 0 || (_registerCustomerResp2 = registerCustomerResponse.data) === null || _registerCustomerResp2 === void 0 || (_registerCustomerResp2 = _registerCustomerResp2.session) === null || _registerCustomerResp2 === void 0 ? void 0 : _registerCustomerResp2.isBlocked;
      navigateToNext(showKycQuestions, isBlocked);
    }
    setIsButtonDisabled(false);
  };
  svs.playerRegistration.logger.debug('KUND:    ', extraData);
  return React.createElement(React.Fragment, null, React.createElement(Header, null), React.createElement(DesktopContentConstrain, null, React.createElement(GridBase, null, !isShortRegistrationFlow && React.createElement("div", {
    className: "margin-bottom-1"
  }, React.createElement(StepIndicatorBalls, {
    isLabelsHidden: true,
    isShowDottedLines: true,
    step: 1
  })), React.createElement(FadeInSlideWrapper, null, React.createElement("div", null, React.createElement(PageTitle, {
    isSuppressData: true
  }, "Hej", ' ', customer === null || customer === void 0 ? void 0 : customer.name, "!"), React.createElement("p", {
    className: "h4 margin-bottom-1"
  }, React.createElement("span", {
    className: "registration-bread-text"
  }, mode === modes.REACTIVATED_NO_EMAIL && 'Innan vi kan återaktivera ditt konto behöver du fylla i din e-postadress.', mode === modes.REACTIVATED_EMAIL && 'Innan du återaktiverar ditt konto behöver du kontrollera att din e-postadress fortfarande är aktuell.', mode === modes.RETAIL && 'Innan du kan spela behöver du skapa ett konto.', mode === modes.NEW && 'Innan du kan spela, skrapa eller rätta behöver du skapa ditt spelkonto hos oss.'))), React.createElement(Form, {
    id: "registerSubmitForm",
    onSubmit: handleSubmit
  }, React.createElement(ControlGroup, {
    infoMessage: "S\xE5 att du kan ta emot spelresultat",
    isLessSpace: true,
    v2: true
  }, React.createElement(ControlGroup, {
    errorMessage: emailCustomError || 'Det här ser inte ut som en riktig e-postadress',
    hasError: !validEmail || Boolean(emailCustomError.length),
    isLessSpace: true,
    v2: true
  }, React.createElement(Inputv2, {
    inputHelpText: "Din e-postadress",
    label: "Fyll i din e-postadress* ",
    name: "email",
    onChange: handleInputChange,
    value: email
  }))), React.createElement("div", {
    className: "data-hj-suppress"
  }, React.createElement(ControlGroup, {
    className: "margin-top-2",
    infoMessage: "S\xE5 att vi kan kontakta dig om du vinner stort",
    isLessSpace: true,
    v2: true
  }, React.createElement(ControlGroup, {
    errorMessage: mobileCustomError || 'Ogiltigt format på mobilnumret',
    hasError: !validMobile || Boolean(mobileCustomError.length),
    isLessSpace: true,
    v2: true
  }, React.createElement(Inputv2, {
    explanation: "123",
    inputHelpText: "Ditt mobilnummer",
    label: "Fyll i ditt mobilnummer",
    name: "mobile",
    onChange: handleInputChange,
    value: mobile
  }))))), React.createElement("div", null, React.createElement("div", {
    className: "margin-top-2 margin-bottom-2"
  }, React.createElement(Button, {
    block: true,
    disabled: isButtonDisabled || !email || !validMobile || !validEmail,
    focus: true,
    form: "registerSubmitForm",
    type: "submit"
  }, React.createElement(React.Fragment, null, (mode === modes.REACTIVATED_NO_EMAIL || mode === modes.REACTIVATED_EMAIL) && 'Återaktivera mitt konto', mode === modes.RETAIL && 'Fortsätt', mode === modes.NEW && 'Skapa konto '))), !isRetail && React.createElement("p", {
    className: "margin-bottom-1"
  }, "Genom att bli kund accepterar jag AB Svenska Spels", ' ', React.createElement(GeneralTermsDocLink, null), ",", ' ', React.createElement(GameRulesPageLink, null), ' ', "och", ' ', React.createElement(PersonalInformationDocLink, null), "."), React.createElement("div", {
    className: "register-clear-both margin-top-1"
  }, React.createElement(ReactInfoButtonText, {
    isUnderline: true,
    onClick: showHowWeUseInfoDialog,
    text: "S\xE5 anv\xE4nder vi dina kontaktuppgifter"
  }), React.createElement("p", {
    className: "margin-v-1"
  }, "Obligatorisk uppgift*")), React.createElement(Footer, {
    isRetail: isRetail
  }))))));
};
svs.playerRegistration.pages.register.Register = Register;

 })(window);